import { render, staticRenderFns } from "./KitFilter.vue?vue&type=template&id=374f47f8"
import script from "./KitFilter.vue?vue&type=script&lang=js"
export * from "./KitFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports